import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueTour from 'vue-tour'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import 'vue-snotify/styles/material.css';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import 'beautify-scrollbar/dist/index.css';
import V2LazyList from 'v2-lazy-list';

Vue.component('date-picker', VuePersianDatetimePicker);

require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)



Vue.use(V2LazyList);

Vue.config.productionTip = true
const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname)
Vue.prototype.BACKEND_LINK = isLocalhost ? 'http://127.0.0.1:8000' : 'https://api.tchtasisat.ir';

let _user = localStorage.getItem('user');

Vue.prototype.$GLOBAL_DATA = {
  user: ''
};
if (_user) {
  try {
    Vue.prototype.$GLOBAL_DATA.user = JSON.parse(_user);
  } catch (e) { }
}

// View:
Vue.prototype.DARK_MODE = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;


const options = {
  bodyMaxLength: 500,
  toast: {
    bodyMaxLength: 500,
    position: SnotifyPosition.rightTop,
  }
}
Vue.use(Snotify, options)

Vue.use(axios, axios)

Vue.mixin({
  methods: {
    check_user_level(user) {
      if ('degree' in user) {
        const routes = {
          4: 'user_4',
          3: 'user_3',
          2: 'user_2',
          1: 'user_1',
        };
        const degree = user.degree in routes ? user.degree : 1;
        if (user['is_superuser']) {
          router.push({ name: 'admin' });
        } else {
          router.push({ name: routes[degree] });
        }
        return degree;
      }
    },
    filter_by_names(items, search_word, name = 'title') {
      function filter_f(item) {
        return item[name].slice(0, search_word.length) === search_word;
      }
      return items.filter(filter_f);
    },
    formatBytes(bytes, decimals = 0) {
      if (!+bytes) return '0 Bytes'
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]} `
    },
    convert_en_to_fa_number: function(str) {
      const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
      return str
          .toString()
          .replace(/\d/g, x => farsiDigits[x]);
    },
    jalali_to_gregorian(jy, jm, jd) {
      jy = parseInt(jy);
      jm = parseInt(jm);
      jd = parseInt(jd);
      let sal_a, gy, gm, gd, days;
      jy += 1595;
      days = -355668 + (365 * jy) + (~~(jy / 33) * 8) + ~~(((jy % 33) + 3) / 4) + jd + ((jm < 7) ? (jm - 1) * 31 : ((jm - 7) * 30) + 186);
      gy = 400 * ~~(days / 146097);
      days %= 146097;
      if (days > 36524) {
        gy += 100 * ~~(--days / 36524);
        days %= 36524;
        if (days >= 365) days++;
      }
      gy += 4 * ~~(days / 1461);
      days %= 1461;
      if (days > 365) {
        gy += ~~((days - 1) / 365);
        days = (days - 1) % 365;
      }
      gd = days + 1;
      sal_a = [0, 31, ((gy % 4 === 0 && gy % 100 !== 0) || (gy % 400 === 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      for (gm = 0; gm < 13 && gd > sal_a[gm]; gm++) gd -= sal_a[gm];
      return [gy, gm, gd];
    },
    // Convert from Fa to En
    convert_fa_to_en_number: function(str) {
      const persianNumberArr = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
          englishNumberArr = [/0/g, /1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g];
      for (let i = 0; i < 10; i++) {
        str = str.replace(persianNumberArr[i], i).replace(englishNumberArr[i], i);
      }
      return str
    },

  },
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
